import { render, staticRenderFns } from "./EmployeeContext.vue?vue&type=template&id=4858c82a&scoped=true"
import script from "./EmployeeContext.vue?vue&type=script&lang=js"
export * from "./EmployeeContext.vue?vue&type=script&lang=js"
import style0 from "./EmployeeContext.vue?vue&type=style&index=0&id=4858c82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858c82a",
  null
  
)

export default component.exports